import * as React from 'react';
import { ConsentItem } from 'app/area/user-profile/my-notifications/consent-item';
import { MeatballMenu, PromptConfirmationModal, ValidationProps } from 'ui';
import { SimpleFormValidation } from 'app/infrastructure/simple-form';
import {
  SerializeMapping, FormWireData, FormValuesType, SimpleFormComponentProps,
  SimpleFormProps
} from 'app/infrastructure/simple-form/types';
import { ConsentType, Consent, ConsentPermission, Subscription } from 'app/area/user-profile/my-notifications/types';
import { EditSmsConsent } from 'app/area/user-profile/my-notifications/consents/edit-sms-consent';
import { MyNotificationTranslation } from 'app/area/user-profile/my-notifications/constants';
import { isChannelActive } from 'app/area/user-profile/my-notifications/consents/channel-permission';

interface ConsentListProps extends SimpleFormProps {
  consent?: Consent;
  consents: Consent[];
  fetchingLoadConsent: boolean;
  fetchingSaveSubscription: boolean;
  formValues: FormValuesType;
  validation: { [key: string]: ValidationProps };
  validate: SimpleFormValidation;
  translation: MyNotificationTranslation;
  formComponent: React.ComponentType<SimpleFormComponentProps>;
  permission?: ConsentPermission;
  serialize: (serializeMapping: SerializeMapping) => FormWireData;
  loadConsents: () => void;
  loadConsent: (id: number, recipientId: number) => void;
  clearConsent: () => void;
  deleteConsent: (id: number, recipientId: number, onSuccess: () => void) => void;
  saveSubscription: (id: number, subscription: Subscription, onSuccess: () => void) => void;
  verifyCode: (subscription: Subscription, onSuccess: () => void) => void;
  clearValidation: (formName: string) => void;
}

export const ConsentList: React.FC<ConsentListProps> = (props: ConsentListProps) => {
  const { consents, permission, loadConsents, deleteConsent, translation } = props;
  const allowedConsents = consents && consents.filter(c => c.type in ConsentType);

  const renderEditView = (consent: Consent) => {
    const editView = {
      [ConsentType.sms]: EditSmsConsent
    };

    const Component = editView[consent.type];
    return <Component {...props} id={consent.id} recipientId={consent.recipientId} />;
  };

  if (allowedConsents && allowedConsents.length === 0) {
    return <p className="no-content">{translation.no_data}</p>;
  }

  return allowedConsents && allowedConsents.map(consent => {
    const handleDelete = deleteConsent && consent && consent.id && consent.recipientId
      ? () => deleteConsent(consent.id, consent.recipientId, loadConsents)
      : undefined;
    const channelActive = permission && isChannelActive(consent.type, permission);

    return <ConsentItem
      {...consent}
      key={consent.id}
      isChannelActive={channelActive}
      translation={translation}>
      <MeatballMenu>
        {channelActive && renderEditView(consent)}
        <li>
          <PromptConfirmationModal
            title={translation.consent_delete}
            description={translation.consent_delete_description}
            continueText={translation.consent_delete}
            cancelText={translation.cancel}
            onContinue={handleDelete}>
            <button type="button" className="dropdown-item">
              {translation.consent_delete}
            </button>
          </PromptConfirmationModal>
        </li>
      </MeatballMenu>
    </ConsentItem>;
  });
};
